import { initializeApp } from "firebase/app";

export const firebaseApp = initializeApp({
  apiKey: "AIzaSyBerVzYsxKALXrT4vSATfNMpeM-7mg82-Q",
  authDomain: "todo-app-db-5bed3.firebaseapp.com",
  databaseURL: "https://todo-app-db-5bed3.firebaseio.com",
  projectId: "todo-app-db-5bed3",
  storageBucket: "todo-app-db-5bed3.appspot.com",
  messagingSenderId: "468114320748",
  appId: "1:468114320748:web:19a635f9beb8ef345a1749",
});
